import {
  formatDate_DDMMMYHMS,
  timeParseNull2,
} from "@/_core/_helpers/_helpers";
import { getCandleData } from "@/_core/data/api_calls/getCandleData";
import { getSpotData } from "@/_core/data/api_calls/getSpotData";
import { timeParse } from "d3";
// ============ Getting spot value from API ===============

export const CommoditiesOps = function(_context) {
  this.context = _context;
  this.merge = {};
};

CommoditiesOps.prototype.getSpotData = function() {
  let _this = this.context;
  _this.spotFactor = null;
  _this.currencyNumber = _this.currencyDefs.pk_i_idcurrency;
  getSpotData(_this, "spotFactor", "updatedAt", "showLoadingSpotFactor")
    .then((data) => {
      const isEndPointBack = _this.faildGetHistoricalData;
      if (isEndPointBack || Array.isArray(data)) {
        _this.spotFactor = Number(data[0].close);
        _this.factorUpdatedAt =
          "Updated at: " + formatDate_DDMMMYHMS(data[0].observation_date);
      } else {
        data = _this.validateDateSpotData(data, "time");
        const date = new Date(data.time);
        _this.spotFactor = data.close;
        _this.factorUpdatedAt = "Updated at: " + formatDate_DDMMMYHMS(date);
      }
      _this.showLoadingSpotFactor = false;
      _this.showLoadingSpot = false;
      this.getCandleData();
    })
    .catch(function(error) {
      _this.showLoadingSpot = false;
      _this.showLoadingSpotFactor = false;
      console.error(error);
    });
};

CommoditiesOps.prototype.getCandleData = function() {
  let _this = this.context;
  _this.currencyNumber = _this.currencyDefs.pk_i_idcurrency;
  _this["showLoading"] = true;
  getCandleData(_this, "technical_analysis_historical")
    .then((data) => {
      _this.currencyHistorical = _this.processData.includeSpot(
        data,
        _this.spotFactor,
        true,
      );
      _this.showLoadingSpotFactor = false;
      _this.showLoading = true;
      this.combineAssets();
    })
    .catch(function(error) {
      _this.showLoading = false;
      _this.currencyHistorical = [];
      console.error(error);
    });
};

CommoditiesOps.prototype.combineAssets = function() {
  let _this = this.context;
  let indexes = _this.currencyHistorical.map(
    (obj) => +obj.date.setHours(0, 0, 0, 0),
  );
  var index = 1,
    index_1 = 0;
  _this.dataConverted = JSON.parse(JSON.stringify(_this.chartDataRaw));
  _this.dataConverted.forEach((d) => {
    d.date = timeParse("%Y-%m-%dT%H:%M:%S.%LZ")(d.date);
    index = indexes.indexOf(+d.date.setHours(0, 0, 0, 0));
    if (index === -1) {
      index = index_1;
    } else {
      index_1 = index;
    }
    d.open = (d.open + _this.freight) * (1 + _this.tariff / 100);
    d.high = (d.high + _this.freight) * (1 + _this.tariff / 100);
    d.low = (d.low + _this.freight) * (1 + _this.tariff / 100);
    d.close = (d.close + _this.freight) * (1 + _this.tariff / 100);
    d.bband_l1 = (d.bband_l1 + _this.freight) * (1 + _this.tariff / 100);
    d.bband_l2 = (d.bband_l2 + _this.freight) * (1 + _this.tariff / 100);
    d.bband_u1 = (d.bband_u1 + _this.freight) * (1 + _this.tariff / 100);
    d.bband_u2 = (d.bband_u2 + _this.freight) * (1 + _this.tariff / 100);
    d.bband_ave = (d.bband_ave + _this.freight) * (1 + _this.tariff / 100);
    d.ma20 = (d.ma20 + _this.freight) * (1 + _this.tariff / 100);
    d.ma40 = (d.ma40 + _this.freight) * (1 + _this.tariff / 100);
    d.ma_40 = (d.ma_40 + _this.freight) * (1 + _this.tariff / 100);
    d.settle = (d.settle + _this.freight) * (1 + _this.tariff / 100);
    d.open_currency = +_this.currencyHistorical[index].open;
    d.high_currency = +_this.currencyHistorical[index].high;
    d.low_currency = +_this.currencyHistorical[index].low;
    d.close_currency = +_this.currencyHistorical[index].close;
    if (_this.defaultOperation === 2) {
      d.open = d.open / d.open_currency;
      d.high = d.high / d.high_currency;
      d.low = d.low / d.low_currency;
      d.close = d.close / d.close_currency;
      d.bband_l1 = d.bband_l1 / d.close_currency;
      d.bband_l2 = d.bband_l2 / d.close_currency;
      d.bband_u1 = d.bband_u1 / d.close_currency;
      d.bband_u2 = d.bband_u2 / d.close_currency;
      d.bband_ave = d.bband_ave / d.close_currency;
      d.ma20 = d.ma20 / d.close_currency;
      d.ma40 = d.ma40 / d.close_currency;
      d.ma_40 = d.ma_40 / d.close_currency;
      d.settle = d.settle / d.close_currency;
    } else if (_this.defaultOperation === 1) {
      d.open = d.open * d.open_currency;
      d.high = d.high * d.high_currency;
      d.low = d.low * d.low_currency;
      d.close = d.close * d.close_currency;
      d.bband_l1 = d.bband_l1 * d.close_currency;
      d.bband_l2 = d.bband_l2 * d.close_currency;
      d.bband_u1 = d.bband_u1 * d.close_currency;
      d.bband_u2 = d.bband_u2 * d.close_currency;
      d.bband_ave = d.bband_ave * d.close_currency;
      d.ma20 = d.ma20 * d.close_currency;
      d.ma40 = d.ma40 * d.close_currency;
      d.ma_40 = d.ma_40 * d.close_currency;
      d.settle = d.settle * d.close_currency;
    }
  });
  _this.showLoading = false;
  _this.dataReady += 1;
};

// ============ Getting historical commodities  from api ===============
CommoditiesOps.prototype.getSpotCommoditiesData = function(
  isContractMonthYear = false,
) {
  let _this = this.context;

  _this.commodityNumber = _this.commodityDefs.pk_idcommodity;
  getSpotData(
    _this,
    "spot",
    "updatedAt",
    isContractMonthYear ? "" : "showLoadingSpot",
    "commodity",
    isContractMonthYear ? _this.defaultSpotData : null,
    isContractMonthYear,
  )
    .then((data) => {
      const isEndpointBack = _this.faildGetHistoricalData;
      data =
        (isEndpointBack && !isContractMonthYear) || Array.isArray(data)
          ? data[0]
          : data;
      if (isContractMonthYear) {
        data = this.parseIntraday(data, _this);
      } else if (data && !isContractMonthYear) {
        this.getConfigurationSpotData(_this, data, isEndpointBack);
      }
      _this.showLoadingSpot = false;
      _this.showLoadingSpotFactor = false;
      if (!isContractMonthYear) {
        if (_this.contractMonthYear != null && _this.contract == null) {
          this.getContractMonthYCommData(
            _this,
            _this.commodityDefs.pk_idcommodity,
            null,
            _this.contractMonthYear,
            "commodity_contract",
          );
        } else {
          this.getCommodityData();
        }
      }
      _this.defaultOperation = 0;
      _this.noneValue = false;
    })
    .catch(function(error) {
      _this.showLoadingSpot = false;
      _this.showLoadingSpotFactor = false;
      console.error(error);
    });
};

CommoditiesOps.prototype.getConfigurationSpotData = function(
  _this,
  data,
  isEndpointBack,
) {
  const dateTime = isEndpointBack ? "last_observation_date" : "time";
  data[dateTime] = isEndpointBack
    ? `${data[dateTime]}${
        _this.processData.isValidTime(data[dateTime]) ? "" : "T00:00:00"
      }`
    : `${data["time"]}`;

  data = _this.validateDateSpotData(data, dateTime);
  _this["spotData"] = data;

  const observationDateTime = data[dateTime];
  let dateObj = new Date(observationDateTime);
  _this["updatedAt"] = "Updated at: " + formatDate_DDMMMYHMS(dateObj);

  if (isEndpointBack) {
    _this["spot"] = Number(data.last_price);
  } else {
    _this["spot"] = Number(data.close);
  }
};

CommoditiesOps.prototype.getContractMonthYCommData = async function(
  _this,
  commodityNumber,
  contract,
  contractMonthYear,
  asset,
) {
  const assetExtraParams = {
    commodityNumber,
    contract,
    contract_month_year: contractMonthYear,
  };

  _this["showLoading"] = true;
  _this["showLoadingSpot"] = true;
  _this["spot"] = 0;

  _this.commodityNumber = _this.commodityDefs.pk_idcommodity;

  try {
    const data = await getCandleData(_this, asset, assetExtraParams);
    const lastData = data.at(-1);
    const spotData = _this.spotData;
    const spotDataClose = spotData ? spotData.close : null;
    _this.contract = lastData.continuous_contract;
    const dataSpotExist = spotData
      ? this.validateRedisSpotExists(spotData, lastData)
      : false;

    // Validate if spot redis data exist
    if (!dataSpotExist) {
      let dataSpot = await getSpotData(
        _this,
        "spot",
        "updatedAt",
        "showLoadingSpot",
        "commodity",
      );
      const isEndpointBack = _this.faildGetHistoricalData;
      dataSpot = isEndpointBack ? dataSpot[0] : dataSpot;

      if (dataSpot) {
        this.getConfigurationSpotData(_this, dataSpot, isEndpointBack);
      }
      _this.showLoadingSpotFactor = false;
    } else {
      _this.spot = spotData[`${spotDataClose ? "close" : "last_price"}`];
    }

    _this.defaultOperation = 0;
    _this.noneValue = false;
    _this["chartDataRaw"] = data;
    _this["dataConverted"] = _this.chartDataRaw;
    _this["showLoadingSpot"] = false;
    _this["showLoading"] = false;
    _this["dataReady"] += 1;
  } catch (error) {
    _this["showLoadingSpot"] = false;
    _this.showLoadingSpotFactor = false;
    _this["showLoading"] = false;
    console.error(error);
  }
};

CommoditiesOps.prototype.parseIntraday = function(data, _this) {
  let parsedData = JSON.parse(JSON.stringify(data));
  if (!Array.isArray(data)) {
    parsedData = [parsedData];
    data = [data];
  }
  parsedData.forEach(function(d) {
    d.last_observation_date = timeParseNull2(d.last_observation_date);
    d.last_trading_date = timeParseNull2(d.last_trading_date);
  });
  parsedData = parsedData.filter((value, index, self) => {
    return (
      self.findIndex(
        (v) => v.contract_month_year === value.contract_month_year,
      ) === index
    );
  });
  Object.assign(_this, { optionsContract: data });
  return _this.optionsContract[
    Math.min(_this.contract - 1, _this.optionsContract.length - 1)
  ];
};

// ============ Getting historical commodities  from api ===============
CommoditiesOps.prototype.getCommodityData = function() {
  let _this = this.context;
  _this["showLoading"] = true;
  let str =
    _this.contract === _this.commodityDefs.selected_contract
      ? "commodity"
      : "commodity_contract";
  getCandleData(_this, str, {
    commodityNumber: _this.commodityDefs.pk_idcommodity,
    contract: _this.contract,
  })
    .then((data) => {
      _this["chartDataRaw"] = _this.processData.includeSpotNew(
        data,
        _this.spotData,
        false,
        true,
      );
      _this["dataConverted"] = _this.chartDataRaw;
      _this["showLoadingSpot"] = false;
      _this["showLoading"] = false;
      _this["dataReady"] += 1;
    })
    .catch(function(error) {
      _this.showLoading = false;
      console.error(error);
    });
};

// ============ Currency Selection ===============
CommoditiesOps.prototype.loadCurrencyParams = function() {
  let _this = this.context;
  if (_this.userCurrencySelection >= 0) {
    _this.currencyDefs = _this.currencySpecs[_this.userCurrencySelection];
    _this.userCurrencySelectionCommodity = _this.currencyDefs.pk_i_idcurrency;
  }
};

// ============ Changing currencies values ==========//
CommoditiesOps.prototype.currencyConverter = function() {
  this.searchAndValid();
  this.context.noneValue = false;
};

CommoditiesOps.prototype.searchAndValid = function() {
  let _this = this.context;
  if (_this.defaultOperation !== 0) {
    _this.noneActive = false;
    this.loadCurrencyParams();
  } else {
    this.reloadNone();
  }
};

CommoditiesOps.prototype.reloadNone = function() {
  let _this = this.context;
  _this.dataConverted = _this.chartDataRaw;
  _this.showLoading = false;
  _this.dataReady += 1;
};

CommoditiesOps.prototype.operate = function(data) {
  let _this = this.context;
  if (_this.defaultOperation === 2) {
    return this.divideCurrency(data);
  } else if (_this.defaultOperation === 1) {
    return this.multiplyCurrency(data);
  }
  return data;
};

CommoditiesOps.prototype.divideCurrency = function(data) {
  let newData = JSON.parse(JSON.stringify(data));
  newData.forEach(function(d) {
    if (d != null) {
      d.open = d.open / d.open_currency;
      d.high = d.high / d.high_currency;
      d.low = d.low / d.low_currency;
      d.close = d.close / d.close_currency;
    }
  });
  this.context.noneValue = true;
  return newData;
};

CommoditiesOps.prototype.clean = function(obj) {
  let index = 0;
  let resultObj = [];
  for (var propName in obj) {
    if (obj[propName] === null || obj[propName] === undefined) {
      delete obj[propName];
    } else {
      resultObj[index] = obj[propName];
      index++;
    }
  }
  return resultObj;
};

CommoditiesOps.prototype.multiplyCurrency = function(data) {
  let newData = JSON.parse(JSON.stringify(data));
  newData.forEach(function(d) {
    if (d != null) {
      d.open = d.open * d.open_currency;
      d.high = d.high * d.high_currency;
      d.low = d.low * d.low_currency;
      d.close = d.close * d.close_currency;
    }
  });
  this.context.noneValue = true;
  return newData;
};

CommoditiesOps.prototype.convertAvailable = function() {
  let _this = this.context;
  _this.conversionAvailable =
    _this.selectedShowView === "seasonality" ||
    _this.selectedShowView === "percentiles" ||
    _this.selectedShowView === "worldCurrencies" ||
    _this.selectedShowView === "comparison" ||
    _this.selectedShowView === "techAnalysis";
};

CommoditiesOps.prototype.validateRedisSpotExists = function(
  spotData,
  lastData,
) {
  return (
    spotData.continuous_contract === lastData.continuous_contract &&
    spotData.contract_month_year === lastData.contract_month_year
  );
};
